import { get, isBoolean, isString } from 'lodash';
import React from 'react';
import { FormFeedback } from 'reactstrap';
import PropTypes from 'prop-types';
import { positionEnum } from 'consts/data';
import { isReactComponent } from 'helpers';
import { Checkbox } from 'shadcn/components/checkbox';
import { cn } from 'helpers/css';

const propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  style: PropTypes.instanceOf(React.CSSProperties),
  onChangeCustomize: PropTypes.func,
  positionLabel: PropTypes.oneOf([positionEnum.left, positionEnum.right]),
};

const CheckBoxField = (props) => {
  const {
    form,
    field,
    label,
    disabled,
    onChangeCustomize,
    afterOnChange,
    positionLabel = positionEnum.left,
    checked,
    defaultChecked,
    classNameContainer,
  } = props;
  const { value } = field || {};
  const { errors, touched } = form || {};

  const name = field?.name || props?.name;

  const handleChange = (checked) => {
    const event = {
      target: {
        name,
        value: checked,
        checked: checked,
      },
    };
    onChangeCustomize && onChangeCustomize(event);
    field && field.onChange(event);
    afterOnChange && afterOnChange(event);
  };

  const renderLabel = () => {
    const clnLabel = 'tw-mb-0';

    if (label) {
      if (isReactComponent(label))
        return (
          <label htmlFor={name} className={clnLabel}>
            {label}
          </label>
        );

      return (
        <label className={clnLabel} htmlFor={name} dangerouslySetInnerHTML={{ __html: label }} />
      );
    }
  };

  return (
    <div
      className={cn('component:CheckBoxField tw-flex tw-items-center tw-gap-2', classNameContainer)}
    >
      {label && positionLabel === positionEnum.left && renderLabel()}
      <Checkbox
        id={name}
        defaultChecked={defaultChecked}
        checked={isBoolean(value) ? value : isString(value) && !!value ? value === 'true' : checked}
        onCheckedChange={handleChange}
        disabled={disabled}
      />
      {label && positionLabel === positionEnum.right && renderLabel()}

      {get(touched, name) && get(errors, name) && <FormFeedback>{get(errors, name)}</FormFeedback>}
    </div>
  );
};

CheckBoxField.propTypes = propTypes;

export default CheckBoxField;
